import { Checkbox } from '@mui/material';
import classNames from 'classnames';
import {
  SelectedFeedsType,
  VendorFeedSpecs,
} from 'new/components/flows/types/elt/CreateELTFlow/types';
import TypographySupport from 'new/elements/TypographySupport';
import React from 'react';
import classes from './SourceSetupPage.module.scss';

interface FeedFieldItemProps {
  label: string;
  value: string;
  feed: string;
  vendorFeedSpecs: VendorFeedSpecs;
  selectedFeeds: SelectedFeedsType;
  onFeedFieldSelectorChanged: (field: string, isChecked: boolean) => void;
}

const FeedFieldItem: React.FC<FeedFieldItemProps> = ({
  label,
  value,
  feed,
  vendorFeedSpecs,
  selectedFeeds,
  onFeedFieldSelectorChanged,
}) => {
  const id = `feed-checkbox-${value}`;
  const currentFeedSettings = selectedFeeds?.[feed];

  const isSelected = !!currentFeedSettings?.selectedFields?.[value];

  return (
    <div
      key={value}
      className={classNames(classes.tableBodyRow, {
        [classes['tableBodyRowSelected']]: isSelected === true,
      })}
    >
      <div className={classes.tableBodyCell}>
        <Checkbox
          id={id}
          checked={isSelected}
          onChange={(event, isChecked) => onFeedFieldSelectorChanged(value, isChecked)}
          size="small"
        />
        <label htmlFor={id}>
          <TypographySupport variant="body1">{label}</TypographySupport>
        </label>
      </div>
      <div className={classes.tableBodyCell}>
        <TypographySupport variant="body1">{value}</TypographySupport>
      </div>
    </div>
  );
};

export default FeedFieldItem;
